import { defineStore } from 'pinia';

export const useBg = defineStore('bg', {
    state: () => ({
        elements: [],
    }),
    getters: {},
    actions: {
        setBg() {
            if (this.elements.length == 0) {
                document.body.style.backgroundColor = '#FFFFFF';
            } else {
                document.body.style.backgroundColor = '#F6EEE3';
            }
            // console.log(this.elements.length);
        },
        add(name) {
            // console.log('Adding ' + name);
            this.elements.push(name);
            this.setBg();
        },
        remove(name) {
            // console.log('Removing ' + name);
            this.elements = this.elements.filter((item) => item !== name);
            this.setBg();
        },
    },
});
